import { render, staticRenderFns } from "./FormProducts.vue?vue&type=template&id=06a36cd7&"
import script from "./FormProducts.vue?vue&type=script&lang=js&"
export * from "./FormProducts.vue?vue&type=script&lang=js&"
import style0 from "./FormProducts.vue?vue&type=style&index=0&id=06a36cd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports